function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import React, { useState, useRef } from "react";
import ReactDOM from "react-dom";
import { injectTestId } from "@cvent/nucleus-test-automation";
import { Manager, Reference, Popper } from "react-popper1";
import useStyle from "./Popover.styles";
import EventSetter from "../EventSetter";
import usePlacement from "./usePlacement";
import { PreferredPlacements } from "./Placements";
import { isHTMLElement } from "./utils";
var Popover = function(_param) {
    var children = _param.children, trigger = _param.trigger, accessibilityLabel = _param.accessibilityLabel, _accessible = _param.accessible, accessible = _accessible === void 0 ? true : _accessible, _defaultOpen = _param.defaultOpen, defaultOpen = _defaultOpen === void 0 ? false : _defaultOpen, _hasPadding = _param.hasPadding, hasPadding = _hasPadding === void 0 ? true : _hasPadding, _isRtl = _param.isRtl, isRtl = _isRtl === void 0 ? false : _isRtl, maxHeight = _param.maxHeight, _nonAnimated = _param.nonAnimated, nonAnimated = _nonAnimated === void 0 ? false : _nonAnimated, _onClose = _param.onClose, onClose = _onClose === void 0 ? function() {} : _onClose, _onOpen = _param.onOpen, onOpen = _onOpen === void 0 ? function() {} : _onOpen, _placement = _param.placement, placement = _placement === void 0 ? PreferredPlacements.bottomStart : _placement, portal = _param.portal, _preventOverflow = _param.preventOverflow, preventOverflow = _preventOverflow === void 0 ? true : _preventOverflow, testID = _param.testID, _useFixed = _param.useFixed, useFixed = _useFixed === void 0 ? false : _useFixed, zIndex = _param.zIndex, _overflowHidden = _param.overflowHidden, overflowHidden = _overflowHidden === void 0 ? true : _overflowHidden, propDrop = _objectWithoutProperties(_param, [
        "children",
        "trigger",
        "accessibilityLabel",
        "accessible",
        "defaultOpen",
        "hasPadding",
        "isRtl",
        "maxHeight",
        "nonAnimated",
        "onClose",
        "onOpen",
        "placement",
        "portal",
        "preventOverflow",
        "testID",
        "useFixed",
        "zIndex",
        "overflowHidden"
    ]);
    var ref4 = _slicedToArray(useState(defaultOpen), 2), isOpen = ref4[0], setIsOpen = ref4[1];
    var containerRef = useRef(null);
    var position = usePlacement(placement, isRtl);
    var ref1 = useStyle(isRtl, isOpen, nonAnimated, zIndex, hasPadding, overflowHidden), mainContainer = ref1.mainContainer, contentContainer = ref1.contentContainer, popoverContainer = ref1.popoverContainer;
    var handleClick = function() {
        setIsOpen(!isOpen);
        if (isOpen) {
            onClose();
        } else {
            onOpen();
        }
    };
    var handleClose = function() {
        if (isOpen) {
            setIsOpen(false);
            onClose();
        }
    };
    var renderPopper = function() {
        var portalRef = portal;
        var popperAndContent = _jsx(Popper, _objectSpread({}, propDrop, {
            placement: position,
            positionFixed: useFixed,
            modifiers: {
                offset: {
                    offset: '0, 4'
                },
                preventOverflow: {
                    enabled: preventOverflow
                },
                hide: {
                    enabled: preventOverflow
                },
                flip: {
                    enabled: maxHeight !== true && preventOverflow
                },
                maxHeight: {
                    enabled: !!maxHeight,
                    order: 800,
                    fn: function(dataObject) {
                        var ref, ref2;
                        var STATIC_OFFSET = 16;
                        var MIN_HEIGHT_THRESHOLD = 300;
                        var viewportHeight = (ref = dataObject.instance.state.scrollParents[0]) === null || ref === void 0 ? void 0 : ref.innerHeight;
                        var minHeightMax = MIN_HEIGHT_THRESHOLD >= viewportHeight ? viewportHeight : MIN_HEIGHT_THRESHOLD;
                        var popperFirstChild = (ref2 = dataObject.instance.popper) === null || ref2 === void 0 ? void 0 : ref2.firstChild;
                        var popperInnerHeight = 0;
                        if (isHTMLElement(popperFirstChild)) {
                            popperInnerHeight = popperFirstChild.offsetHeight;
                        }
                        var minHeightMin = MIN_HEIGHT_THRESHOLD >= popperInnerHeight ? popperInnerHeight : MIN_HEIGHT_THRESHOLD;
                        var computedMinHeight = minHeightMax >= minHeightMin ? minHeightMin : minHeightMax;
                        var computedMaxHeight;
                        if (typeof maxHeight === 'number') {
                            computedMaxHeight = maxHeight;
                        } else if (maxHeight === true) {
                            var ref3;
                            var popperTop = (ref3 = dataObject.offsets.popper) === null || ref3 === void 0 ? void 0 : ref3.top;
                            if (viewportHeight && popperTop) {
                                computedMaxHeight = viewportHeight - popperTop - STATIC_OFFSET;
                            }
                        }
                        if (computedMaxHeight) {
                            dataObject.styles.maxHeight = "".concat(computedMaxHeight, "px");
                            dataObject.styles.minHeight = "".concat(computedMinHeight, "px");
                        }
                        return dataObject;
                    }
                }
            },
            children: function(param) {
                var ref = param.ref, style = param.style, dataPlacement = param.placement;
                return _jsx("div", {
                    ref: ref,
                    css: _objectSpread({}, popoverContainer, style),
                    "data-placement": dataPlacement,
                    children: _jsx(EventSetter, {
                        containerRef: containerRef,
                        onDismiss: handleClose,
                        children: _jsx("div", {
                            ref: containerRef,
                            css: contentContainer,
                            "aria-label": accessibilityLabel,
                            "aria-hidden": !accessible,
                            children: typeof children === 'function' ? children({
                                closePopover: handleClose
                            }) : children
                        })
                    })
                });
            }
        }));
        if (portalRef) {
            var portalTarget = portalRef === true ? window.document.body : portalRef;
            return ReactDOM.createPortal(popperAndContent, portalTarget);
        }
        return popperAndContent;
    };
    return _jsxs(Manager, {
        children: [
            _jsx(Reference, {
                children: function(param) {
                    var ref = param.ref;
                    return _jsx("div", {
                        ref: ref,
                        children: trigger({
                            toggleOpen: handleClick,
                            isOpen: isOpen,
                            closePopover: handleClose
                        })
                    });
                }
            }),
            isOpen && _jsx("div", _objectSpread({
                css: mainContainer
            }, injectTestId(testID), {
                children: renderPopper()
            }))
        ]
    });
};
export { Popover };
